/* eslint-disable import/prefer-default-export */
export const getStoreIcon = (store) => {
  // *-icon classes are in ProductList.vue (for colors)
  const iconMap = {
    fanatics: 'fak fa-fanatics fanatics-icon',
    amazon: 'fab fa-amazon amazon-icon',
  };

  return iconMap[store];
};
